import { Node, mergeAttributes } from '@tiptap/core';

export const StreamingNode = Node.create({
  name: 'streamingNode',

  group: 'block',

  atom: true, 

  addAttributes() {
    return {
      htmlContent: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'streaming-node',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['streaming-node', mergeAttributes(HTMLAttributes), 0];
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement('div');
      dom.classList.add('streaming-node');

      // Dynamically set innerHTML from the node attribute
      // dom.innerHTML = '<div class="streaming-node-parsed"></div><div class="streaming-node-buffer"></div>';

      return {
        dom,
        update: (updatedNode) => {
          // if (updatedNode.type !== node.type) {
          //   return false;
          // }

          // Update the innerHTML if the node changes
          // dom.innerHTML = updatedNode.attrs.htmlContent;
          return true;
        },
      };
    };
  },
});
